import api from './axios';
import type { Notification } from '../stores/notificationStore';

export async function getNotifications(): Promise<Notification[]> {
  const { data } = await api.get<{ data: Notification[] }>('/api/v2/notifications');
  return data.data;
}

export async function markAllRead(): Promise<void> {
  await api.post('/api/v2/notifications/read-all');
}
